import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
const httpLink = new HttpLink({
    uri: `${process.env.BFF_URL}`,
})

export const ApolloClientBff = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache({
        resultCaching: true,
    }),
})
